var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"q-mb-xs text-weight-medium text-grey-10"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.lastUpdated)?_c('span',{staticClass:"text-tab"},[_vm._v(" Last Updated Date: "+_vm._s(_vm.lastUpdated)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }